'use es6';

import { SET_AUTH } from 'simple-menus-core/actions/ActionTypes';
export function setAuth(auth) {
  return {
    type: SET_AUTH,
    payload: auth
  };
}